import { isFeatureEnabled, initialize, whenAvailable } from '@vp/ab-reader';
import { useState, useEffect, useCallback } from 'react';

const useFeatureToggle = () => {
  const [isClientAvailable, setIsClientAvailable] = useState(false);
  useEffect(() => {
    const fetchFeatureTogglesClient = async () => {
      initialize();
      whenAvailable((available) => {
        if (available) {
          setIsClientAvailable(true);
        }
      }, 3e3);
    };
    fetchFeatureTogglesClient();
  }, []);
  const isFeatureFlagEnabled = useCallback(
    (featureFlag) => {
      return isClientAvailable ? isFeatureEnabled(featureFlag) : false;
    },
    [isClientAvailable]
  );
  return { isFeatureFlagEnabled };
};

export { useFeatureToggle };
//# sourceMappingURL=src-hooks-useFeatureToggle.js.map
